import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TrendLegendData,TrendLegendColors } from './trend-legend.model';

@Component({
    selector: 'widgets-trends-legend',
    templateUrl: './trends-legend.component.html',
    styleUrls: ['./trends-legend.component.scss'],
    standalone: false
})
export class TrendsLegendComponent implements OnInit {

  @Input()
  lineChartData: TrendLegendData[] = [];

  @Input()
  browserLabel: string = 'commons.search';

  @Input()
  lineChartColors: TrendLegendColors[] = [];

  @Input()
  displayBtn: string = '';

  @Input()
  showAccordion: boolean = true;

  @Output()
  filterCustomerChange: EventEmitter<TrendLegendData[]> = new EventEmitter();

  searchTerm: string = '';
  hideContent: boolean = false;

  constructor() { }

  ngOnInit() {
  }

  toggleLegend(data: TrendLegendData){
    data.hidden = !data.hidden
    this.emitChanges();
  }

  selectedAll(status){
    this.lineChartData.map(x=>x.hidden = !status);
    this.emitChanges()
  }

  emitChanges(){
    this.filterCustomerChange.emit(this.lineChartData);
  }

  get filteredChartData() {
    if (!this.searchTerm || this.searchTerm.trim() === '') {
      return this.lineChartData || [];
    }

    const searchTermLower = this.searchTerm.toLowerCase();
    return (this.lineChartData || []).filter(item => 
      item.label && item.label.toLowerCase().includes(searchTermLower)
    );
  }

  getColorForItem(data, index) {
    if (this.searchTerm && this.searchTerm.trim() !== '') {
      const originalIndex = this.lineChartData.findIndex(item => item === data);
      return originalIndex !== -1 
        ? this.lineChartColors[originalIndex]?.backgroundColor 
        : this.lineChartColors[index]?.backgroundColor;
    }
    
    return this.lineChartColors[index]?.backgroundColor;
  }

}
